var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"scrollRef",staticClass:"base-el-scrollbar",on:{"input":function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey)return null;return _setup.handleInput.apply(null, arguments)},"keyup":_setup.handleKeyup}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }